export default __webpack_public_path__ + "static/media/exam-topic-remark-icon.ae587504.svg";